import { Dialog, DialogContent } from "./ui/dialog";
import { Bookmark, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

const PENDING_KEY = "dealhub.pending_save";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
function stashPending(payload) {
  try {
    localStorage.setItem(PENDING_KEY, JSON.stringify(payload));
  } catch (err) {
    console.warn("Could not stash pending save:", err);
  }
}

/**
 * Guest-only modal shown when a shopper clicks "Save" on a live web deal.
 * Stashes the deal payload in localStorage before launching auth so we can
 * finish the save automatically the moment they land back.
 */
export default function SignInToSaveModal({ open, onClose, payload }) {
  const startGoogle = () => {
    if (payload) stashPending(payload);
    const redirectUrl = window.location.origin + "/auth/callback";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  const goEmail = () => {
    if (payload) stashPending(payload);
    onClose?.();
  };

  return (
    <Dialog open={open} onOpenChange={(v) => { if (!v) onClose?.(); }}>
      <DialogContent className="max-w-md p-0 rounded-none border-2 border-black" data-testid="sign-in-to-save-modal">
        <div className="p-6">
          <div className="flex items-center gap-2 text-[10px] font-bold uppercase tracking-[0.25em] text-[#E63946] mb-3">
            <Bookmark className="w-3.5 h-3.5" strokeWidth={2} /> Save this deal
          </div>
          <h2 className="font-serif font-black text-3xl leading-tight tracking-tighter mb-3">
            One tap to keep it.
          </h2>
          <p className="text-sm text-black/60 mb-2">
            Sign in and we&rsquo;ll drop
            {payload?.title ? <> <span className="font-bold text-black">&ldquo;{String(payload.title).slice(0, 60)}&rdquo;</span></> : " this find"}
            {" "}into your bookmarks in a heartbeat.
          </p>
          <p className="text-xs text-black/40 mb-6">
            No spam. Just your saved deals waiting when you return.
          </p>

          <button
            type="button"
            onClick={startGoogle}
            className="w-full flex items-center justify-center gap-3 border-2 border-black bg-white text-black px-6 py-3 font-bold uppercase tracking-widest text-xs hover:bg-black hover:text-white transition-colors"
            data-testid="modal-google-signin"
          >
            <GoogleG />
            Continue with Google
          </button>

          <div className="flex items-center gap-3 my-4" aria-hidden="true">
            <div className="flex-1 h-px bg-black/10" />
            <span className="text-[10px] font-mono uppercase tracking-widest text-black/40">or</span>
            <div className="flex-1 h-px bg-black/10" />
          </div>

          <div className="flex flex-col sm:flex-row gap-3">
            <Link
              to="/login"
              onClick={goEmail}
              className="flex-1 text-center border border-black px-4 py-2.5 font-bold uppercase tracking-widest text-xs hover:bg-black hover:text-white"
              data-testid="modal-email-login"
            >
              Log in with email <ArrowRight className="inline w-3 h-3 ml-1" strokeWidth={2.5} />
            </Link>
            <Link
              to="/register"
              onClick={goEmail}
              className="flex-1 text-center border border-black/20 text-black/70 px-4 py-2.5 font-bold uppercase tracking-widest text-xs hover:border-black hover:text-black"
              data-testid="modal-register"
            >
              Create an account
            </Link>
          </div>

          <p className="text-[10px] font-mono uppercase tracking-widest text-black/35 mt-4 text-center">
            We&rsquo;ll finish saving the deal the moment you land back.
          </p>
        </div>
      </DialogContent>
    </Dialog>
  );
}

function GoogleG() {
  return (
    <svg width="18" height="18" viewBox="0 0 48 48" aria-hidden="true">
      <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/>
      <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/>
      <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"/>
      <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/>
    </svg>
  );
}

export { PENDING_KEY };
